import { PointsHistoryEndpoint } from '@api/endpoints/PointsHistoryEndpoint';
import { Client } from './Client';

export class PointsHistoryApi {
  static updateManualPoints (
    userId: string,
    id: string,
    body: PointsHistoryEndpoint.Update.Request,
  ): Promise<void> {
    return Client(`users/${userId}/points-histories/${id}`, {
      method: 'PATCH',
      body,
    });
  }
}
